import { apiManager } from "@/services/api"
import type {
  ContentGet,
  ContentViewed,
  CurrentVersion
} from "@/types/contents"

export class ContentsApi {
  public getAllContents = () => apiManager.get<ContentGet[]>("/api/v1/versions")

  public getContent = (id: number) =>
    apiManager.get<ContentGet>(`/api/v1/versions/${id}`)

  public getCurrentVersion = () =>
    apiManager.get<CurrentVersion>("/api/v1/versions/current")

  public getHighlightContent = () =>
    apiManager.get<ContentGet>("/api/v1/versions/modal")

  public markContentAsViewed = (data: ContentViewed) =>
    apiManager.post(`/api/v1/visualized-contents/${data.content_id}`, data)
}
